export default __webpack_public_path__ + "static/media/avatar.33f1d356.jpg";